import moment from 'moment-timezone';

import { FormFieldColumn } from '../../common/register/form-field-column/form-field-column';

export class DateFieldColumn extends FormFieldColumn {
  constructor(item, renderer) {
    super(item, renderer);

    this.content = item.value ? moment(item.value).format('ll') : '';
  }
}
